import { render, staticRenderFns } from "./InfoEditor.vue?vue&type=template&id=6de7eaa0&"
import script from "./InfoEditor.vue?vue&type=script&lang=ts&"
export * from "./InfoEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports